import { InterviewsDataState, InterviewsState } from './types';

export const INITIAL_INTERVIEWS_DATA_STATE: InterviewsDataState = {
  actionItems: [],
  upcomingInterviews: [],
};

export const INITIAL_INTERVIEWS_STATE: InterviewsState = {
  ...INITIAL_INTERVIEWS_DATA_STATE,
  actionItemsLoading: false,
  actionItemsError: null,
  actionItemsSuccess: null,

  upcomingInterviewsLoading: false,
  upcomingInterviewsError: null,
  upcomingInterviewsSuccess: null,
};
